import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { PasswordInput } from './../../password-input';
import { UseFormReturn } from 'react-hook-form';

interface PasswordFieldProps {
  form: UseFormReturn<any>;
  name: string;
  label: string;
}

export const PasswordField = ({ form, name, label }: PasswordFieldProps) => {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="font-medium">{label}</FormLabel>
          <FormControl>
            <PasswordInput field={field} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
